export default {"src":"/_next/static/media/wg.3df06b11.svg","height":422,"width":421,"blurWidth":0,"blurHeight":0};